import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import HeaderBackendComponent from "../../components/Header/headerBackendMobile";
import ProductsIndex from "../../components/products";



const Products = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Producten" subtitle="JesseFresh" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <HeaderBackendComponent/>
    <ProductsIndex />
    
  </Container>
);

export default Products;
